import $ from 'jquery'
import React from 'react'
import { getQueryDescription } from "./SearchLink";

const STEP = 4;

// hack to do a quick jump to start of results on page select
function scrollStart() {
    try {
        window.scrollTo(0, window.scrollY + $('.tabs-widget')[0].getBoundingClientRect().top);
    } catch (e) {}
}

function add(s, f, curPage, onChange) {
    let items = []
    for (let i = s; i < f; ++i) {
        items.push(
            <li key={i}>
                <a

                    aria-label={i + 1}
                    className={(i === curPage ? "current" : "")}
                    onClick={(e) => {
                        e.preventDefault();
                        if (onChange && i !== curPage) {
                            scrollStart();
                            onChange(i);
                        }
                    }}
                >
                    {i + 1}
                </a>
            </li>
        );
    }
    return items
}

function first(curPage, onChange) {
    let items = []
    items.push(
        <li
            key={0}>
            <a
                aria-label={0 + 1}
                className={(0 === curPage ? "current" : "")}
                onClick={(e) => {
                    e.preventDefault();
                    if (onChange && 0 !== curPage) {
                        scrollStart();
                        onChange(0);
                    }
                }}
            >
                {1}
            </a>
        </li>
    );
    items.push(
        <li className="ellipsis" aria-hidden="true"
            key={2}></li>
    );
    return items
}

function last(curPage, l, onChange) {
    let items = []
    items.push(
        <li className="ellipsis" aria-hidden="true"
            key={l - 1}></li>
    );
    items.push(
        <li
            key={l}>
            <a
                aria-label={l + 1}
                className={(l === curPage ? "current" : "")}
                onClick={(e) => {
                    e.preventDefault();
                    if (onChange && l !== curPage) {
                        scrollStart();
                        onChange(l);
                    }
                }}
            >
                {l + 1}
            </a>
        </li>
    );
    return items
}

function Pagination({ numPages, curPage, onChange }) {


    if (!numPages || numPages < 2)
        return null;

    let items = [];

    if (numPages < STEP * 2 + 6) {
        items.push(add(0, numPages, curPage, onChange));
    }
    else if (curPage < STEP * 2 + 1) {
        items.push(add(0, STEP * 2 + 4, curPage, onChange));
        items.push(last(curPage, numPages - 1, onChange))
    }
    else if (curPage > numPages - STEP * 2) {
        items.push(first(curPage, onChange))
        items.push(add(numPages - STEP * 2 - 2, numPages, curPage, onChange));
    }
    else {
        items.push(first(curPage, onChange))
        items.push(add(curPage - STEP, curPage + STEP, curPage, onChange));
        items.push(last(curPage, numPages - 1, onChange))
    }

    return (
        <nav className="pagination" aria-label="Pagination">
            <ul>
                <li key={0}>
                    <a className={(curPage == 0 ? " disabled" : "")} onClick={(e) => {
                        e.preventDefault();
                        if (onChange && curPage != 0) {
                            scrollStart();
                            onChange(curPage - 1);
                        }
                    }}>
                        &#171;
                    </a>
                </li>
                {items}
                <li key={numPages}>
                    <a className={(curPage == numPages - 1 ? " disabled" : "")}
                        onClick={(e) => {
                            e.preventDefault();
                            if (onChange && curPage != numPages - 1) {
                                scrollStart();
                                onChange(curPage + 1);
                            }
                        }}
                    >
                        &#187;
                    </a>
                </li>
            </ul>
        </nav>
    );
}

export default Pagination



// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/Pagination.js